import script from "./FileImporter.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileImporter.vue?vue&type=script&setup=true&lang=ts"

import "./FileImporter.vue?vue&type=style&index=0&id=720f19d0&scoped=true&lang=css"

import exportComponent from "/builds/SalesIT/ijaa/import-tool/ls-import-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-720f19d0"]])

export default __exports__